const NS = 'SiteFooterWoolLab';
const CLS = 'siteFooterWoolLab';
const WG = '.' + CLS + '-';

import utils from '../utils';

export class SiteFooterWoolLab {
	constructor($el) {
		this.$el = $el;
	}

	init() {
		this.showButtonFooter();

		const $wg = $(this.$el);
		let $selectedLangItem = $wg.find(WG+'langItem.is-selected');
		const $langToggle = $wg.find(WG+'langToggle');

		// if none selected picks first one
		if (!$selectedLangItem.length) {
			let $langItems = $wg.find(WG+'langItem');
			if($langItems.length) {
				$selectedLangItem = $langItems.eq(0);
				$selectedLangItem.addClass('is-selected');
			}
		}

		if($selectedLangItem) $langToggle.text( $selectedLangItem.text() );

		let $siteFooterSiteMap = $wg.find('.siteFooterSitemap');
		let $linkMore = $wg.find(WG+'link--more');

		$linkMore.on('click', () => {
			$siteFooterSiteMap.trigger('siteFooterSitemap.toggle', {});
		});

		$wg.on('siteFooter.sitemapButton.toggleClass', () => {
			if($siteFooterSiteMap.attr('data-closed') === 'false') {
				$linkMore.addClass(`active`);
			}
			else {
				$linkMore.removeClass(`active`);
			}
		});
	}

	// button share, back to top, and reading tab will show on scroll
	showButtonFooter() {
		let $wg = $(this.$el);
		const clsHasScrolled = 'has-scrolled';

		$(window).on('scroll', () => {
			if(!utils.checkBP('tp')) {
				if($(window).scrollTop() > 100) {
					$wg.addClass(clsHasScrolled);
				} else {
					$wg.removeClass(clsHasScrolled);
				}
			}
		});

		$(window).on('resize', () => {
			if(utils.checkBP('tp')) {
				$wg.removeClass(clsHasScrolled);
			}
		});
	}
}
